import React from 'react'
import { func, shape, bool, string } from 'prop-types'
import { translate } from 'react-i18next'
import { ProposalStatus } from '../../../constants/ProposalStatus'
import { GoToDevisButton } from '../../../components/ui/buttons/GoToDevisButton'
import { CancellationButton } from '../../../components/ui/buttons/CancellationButton'

export const ProposalsActions = translate()(({ id, isMaintenance, proposal, t }) => {
  switch (proposal.status) {
  case ProposalStatus.CANCELLED:
    return (<span>{ t('common:visits:cancel_title') }</span>)
  case ProposalStatus.FINISHED:
    return (
      <div>
        <div className='demandes__reponses__actions--validated'>{ t('common:visits:finished') }</div>
        <GoToDevisButton isMaintenance={isMaintenance} id={id} />
      </div>
    )
  default:
    return (
      <div>
        <div className='demandes__reponses__actions--validated'>
          {t('common:visits:accepted')}
        </div>
        <CancellationButton id={proposal.id} />
      </div>
    )
  }
})

ProposalsActions.propTypes = {
  t: func,
  id: string,
  isMaintenance: bool,
  proposal: shape({
    id: string,
    status: string
  })
}



// WEBPACK FOOTER //
// ./src/pages/demandes/visits/ProposalsActions.js